import { ReactNode } from "react";

interface TitleProps {
    children: ReactNode;
}

export default function Title(props: TitleProps) {
    return (
        <h2 className="font-bold text-3xl text-center mb-10">
            {props.children}
        </h2>
    );
}
